<template>
  <div :class="['back-btn', backValue ? '' : 'hide-btn']">
    <img :src="require('../assets/images/ico_home.png')" @click="backHome()" />
    <img
      :class="showList ? 'selected' : ''"
      :src="require('../assets/images/ico_list.png')"
      @click="showMenu($event)"
    />

    <!-- 菜单列表 -->
    <div :class="['menu-list', showList ? '' : 'menu-list-hide']">
      <div
        v-for="(item, index) in list"
        :key="index"
        @click="changeView(item, index)"
      >
        <span>{{ item.title }}</span>
        <img
          v-show="selectedIndex == index"
          src="../assets/images/ico_choice.png"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "float-button",

  props: {
    list: {
      type: Array,
      default: () => [],
    },
    /**
     * pageType "page" commonPage "detail" 视频详情
     */
    pageType: {
      type: String,
      default: "page",
    },
    bgColor: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      backValue: false,
      showList: false,
      selectedIndex: 0,
    };
  },

  mounted() {
    let _self = this;
    _self.timer = setTimeout(function() {
      _self.backValue = true;
    }, 500);
    window.addEventListener("scroll", function() {
      _self.backValue = false;
      _self.showList = false;
      clearTimeout(_self.timer);
      _self.timer = setTimeout(function() {
        _self.backValue = true;
      }, 500);
    });
  },

  watch: {
    "$route.query": {
      handler() {
        this.getParams();
        // this.setBgColor();
      },
      immediate: true,
    },
  },

  methods: {
    /**
     * 返回至主页
     */
    backHome() {
      this.$router.push("/");
    },

    /**
     * 展示菜单与否
     */
    showMenu() {
      this.showList = !this.showList;
    },

    /**
     * 获取参数
     */
    getParams() {
      const { key, index } = this.$route.query;
      if (this.pageType == "page") {
        // 算法页面
        this.selectedIndex = this.list.findIndex((item) => item.key == key);
      } else {
        // 算法详情页面
        this.selectedIndex = index;
      }
      this.setBgColor();
    },

    /**
     * 设置页面背景色
     */
    setBgColor() {
      document
        .querySelector("body")
        .setAttribute(
          "style",
          "background-color: " +
            (this.list[this.selectedIndex].bgColor || this.bgColor)
        );
    },

    /**
     * 同层级切换
     */
    changeView(item, index) {
      if (this.selectedIndex == index) return;
      if (this.pageType == "page") {
        this.$router.push({
          path: "/commonPage",
          query: {
            key: item.key,
          },
        });
      } else {
        this.$router.push({
          path: "/detect-details",
          query: {
            key: this.$route.query.key,
            index,
            typeIndex: this.$route.query.typeIndex,
          },
        });
      }
      this.getParams();
      setTimeout(() => {
        this.showList = false;
      }, 200);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/varibles.scss";
.back-btn {
  width: 104px;
  height: 52px;
  padding: 4px;
  z-index: 1;
  border-radius: 12px;
  background-color: #262626cc;
  box-shadow: 0 2px 8px 0 #00000080;
  position: fixed;
  left: 16px;
  bottom: 36px;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: space-between;
  > img {
    width: 44px;
    height: 44px;
    padding: 10px;
  }
  .selected {
    border-radius: 6px;
    background-color: #ffffff33;
  }
}
.hide-btn {
  left: -98px;
}

.menu-list {
  position: fixed;
  bottom: 100px;
  left: 16px;
  padding-left: 16px;
  width: 236px;
  max-height: 461px;
  background-color: #262626;
  overflow-y: auto;
  border-radius: 8px;
  box-sizing: border-box;
  div {
    height: 44px;
    line-height: 44px;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      font-size: 14px;
      font-weight: 400;
      color: #b5b5b5;
    }
    img {
      width: 16px;
      height: 16px;
      margin-right: 16px;
    }
    &:not(:last-child) {
      border-bottom: 0.5px solid #4d4d4d;
    }
  }
  &-hide {
    max-height: 0 !important;
  }
}
@media screen and (min-width: $maxWidth) {
  .back-btn {
    width: 104px;
    height: 52px;
    padding: 4px;
    border-radius: 12px;
    box-shadow: 0 2px 8px 0 #00000080;
    left: 16px;
    bottom: 36px;
    > img {
      width: 44px;
      height: 44px;
      padding: 10px;
    }
    .selected {
      border-radius: 6px;
    }
  }
  .hide-btn {
    left: -98px;
  }

  .menu-list {
    bottom: 100px;
    left: 16px;
    padding-left: 16px;
    width: 236px;
    max-height: 461px;
    border-radius: 8px;
    div {
      height: 44px;
      line-height: 44px;
      span {
        font-size: 14px;
        font-weight: 400;
      }
      img {
        width: 16px;
        height: 16px;
        margin-right: 16px;
      }
      &:not(:last-child) {
        border-bottom: 0.5px solid #4d4d4d;
      }
    }
  }
}
</style>
